// const HomePage = lazy(() => import('pages/HomePage/HomePage'));
import { permissions } from 'hooks/permissions/permissions';
import BaseRolesPage from 'pages/AccessControl/BaseRolesPage';
import PermissionsPage from 'pages/AccessControl/PermissionsPage';
import RolePermissionsList from 'pages/AccessControl/RolePermissionsList';
import RolesPage from 'pages/AccessControl/RolesPage';
import Baskets from 'pages/Baskets/Baskets';
import BranchDetails from 'pages/Branches/BranchDetails';
import BranchesList from 'pages/Branches/Branches';
import CarBrand from 'pages/CarBrand/CarBrand';
import CardexList from 'pages/Cardex/Cardex';
import CarFactory from 'pages/CarFactory/CarFactory';
import CarModel from 'pages/CarModel/CarModel';
import CarProductionTime from 'pages/CarProductionTime/CarProductionTime';
import CarSeries from 'pages/CarSeries/CarSeries';
import CodeGroup from 'pages/CodeGroup/CodeGroup';
import CodingAttribute from 'pages/CodingAttribute/CodingAttribute';
import CodingGroupList from 'pages/CodingProfile/CoddingGroupList/CoddingGroupList';
import CodingProfile from 'pages/CodingProfile/CodingProfile';
import HomePage from 'pages/HomePage/HomePage';
import LocationDetail from 'pages/LocationDetail/LocationDetail';
import LocationsCategories from 'pages/LocationsCategories/LocationsCategories';
import MappingIndex from 'pages/MappingIndex/MappingIndex';
import MappingProfile from 'pages/MappingProfile/MappingProfile';
import ActivePDAListPage from 'pages/Operation/ActivePDAList/ActivePDAListPage';
import DepartureOperationList from 'pages/Operation/Departure/DepartureOperationList';
import DepartureOperationWorkspace from 'pages/Operation/Departure/Workspace/DepartureOperationWorkspace';
import EntryOperationList from 'pages/Operation/Entry/EntryOperationList';
import EntryOperationWorkspace from 'pages/Operation/Entry/Workspace/EntryOperationWorkspace';
import MovementOperationList from 'pages/Operation/Movement/MovementOperationList';
import MovementOperationWorkspace from 'pages/Operation/Movement/Workspace/MovementOperationWorkspace';
import TransferOperationList from 'pages/Operation/Transfer/TransferOperationList';
import TransferOperationWorkspace from 'pages/Operation/Transfer/Workspace/TransferOperationWorkspace';
import ProductBranch from 'pages/ProductBranch/ProductBranch';
import ProductCategories from 'pages/ProductCategories/ProductCategories';
import ProductDetail from 'pages/ProductDetail/ProductDetail';
import ProductList from 'pages/ProductList/ProductList';
import StockTakeList from 'pages/StockeTake/StockeTake';
import UserPermissionList from 'pages/Users/UserPermissionList';
import UserRoleList from 'pages/Users/UserRoleList';
import UsersPage from 'pages/Users/UsersPage';
import ApplicationsPage from 'pages/VersionControl/ApplicationsPage';
import VersionControlPage from 'pages/VersionControl/VersionControlPage';
import WarehouseOperationDefaultSettings from 'pages/WarehouseOperation/OperationDefaultSettings/OperationDefaultSettings';
import WarehouseOperationGeoMap from 'pages/WarehouseOperation/OperationGeoMap/OperationGeoMap';
import WMSReports from 'pages/WMSReports/WMSReports';

const categoriesPermissions = permissions.general.categories;
const productList =
  categoriesPermissions.globalSettings.productManagement.productList;
const branchList =
  categoriesPermissions.globalSettings.productManagement.branchList;
const usersPermissions =
  categoriesPermissions.globalSettings.usersManagement.users;
const warehouseOperations = categoriesPermissions.warehouseOperations;
const codingSettings = categoriesPermissions.globalSettings.coddingSettings;
const warehouseManagement = categoriesPermissions.warehouseManagement;
const locationManagement =
  categoriesPermissions.warehouseManagement.locationManagement;
const keySettings = categoriesPermissions.keySettings;
const defaultSettings = permissions.general.defaultSettings;

export const routes = [
  {
    id: '1',
    path: '/',
    element: <ProductList />,
    label: 'محصولات',
    refreshVersion: 0,
    permission: productList.view,
  },
  {
    id: '2',
    path: '/locations/:guid',
    element: <LocationDetail />,
    label: 'مناطق',
    refreshVersion: 0,
    permission: locationManagement.locations.detail,
  },
  {
    id: '3',
    path: '/stock-take',
    element: <StockTakeList />,
    label: 'انبارگردانی',
    refreshVersion: 0,
    permission: warehouseManagement.locationManagement.stockTake,
  },
  {
    id: '4',
    path: '/WMS-reports',
    element: <WMSReports />,
    label: 'گزارشات',
    refreshVersion: 0,
    permission: warehouseManagement.locationManagement.reports,
  },
  {
    id: '5',
    path: '/baskets/:guid',
    element: <Baskets />,
    label: 'سبد ها',
    refreshVersion: 0,
    permission: locationManagement.locations.areas.baskets.view,
  },
  {
    id: '6',
    path: '/locations',
    element: <HomePage />,
    label: 'مکان‌ ها',
    refreshVersion: 0,
    permission: warehouseManagement.locationManagement.view,
  },
  {
    id: '7',
    path: '/branchesList',
    element: <BranchesList />,
    label: 'برنچ ها',
    refreshVersion: 0,
    permission: branchList.view,
  },
  {
    id: '7-details',
    path: '/branches/:branchGuid',
    element: <BranchDetails />,
    label: 'جزئیات برنچ',
    refreshVersion: 0,
    permission: branchList.detail,
  },
  {
    id: '8',
    path: '/cardex',
    element: <CardexList />,
    label: 'کاردکس',
    refreshVersion: 0,
    permission: warehouseManagement.cardex,
  },
  {
    id: '9',
    path: '/codeGroup',
    element: <CodeGroup />,
    label: 'گروه کد',
    refreshVersion: 0,
    permission: codingSettings.groupCode.view,
  },
  {
    id: '10',
    path: '/profileGroup',
    element: <CodingProfile />,
    label: 'کد پروفایل',
    refreshVersion: 0,
    permission: codingSettings.profileGroup.view,
  },
  {
    id: '11',
    path: '/codingAttribute/:guid',
    element: <CodingAttribute />,
    label: 'مقادیر کد',
    refreshVersion: 0,
    permission: codingSettings.groupCode.values.view,
  },
  {
    id: '12',
    path: '/coding-groups-list/:guid',
    element: <CodingGroupList />,
    label: 'لیست گروه کد‌ها',
    refreshVersion: 0,
    permission: codingSettings.profileGroup.detail,
  },
  {
    id: '13',
    path: '/mappingProfile',
    element: <MappingProfile />,
    label: 'مپ پروفایل',
    refreshVersion: 0,
    permission: codingSettings.mappingProfile.view,
  },
  {
    id: '14',
    path: '/mappingIndex/:guid',
    element: <MappingIndex />,
    label: 'مقادیر مپ پروفایل',
    refreshVersion: 0,
    permission: codingSettings.mappingProfile.detail,
  },
  {
    id: '15',
    path: '/carFactory',
    element: <CarFactory />,
    label: 'مدل خودرو ها',
    refreshVersion: 0,
    permission: codingSettings.carFactory.view,
  },
  {
    id: '16',
    path: '/carBrand/:guid',
    element: <CarBrand />,
    label: 'برند ها',
    refreshVersion: 0,
    permission: codingSettings.carFactory.brands.view,
  },
  {
    id: '17',
    path: '/carModel/:guid',
    element: <CarModel />,
    label: 'مدل های خودرو',
    refreshVersion: 0,
    permission: codingSettings.carFactory.brands.models.view,
  },
  {
    id: '18',
    path: '/carSeries/:guid',
    element: <CarSeries />,
    label: 'سری های خودرو',
    refreshVersion: 0,
    permission: codingSettings.carFactory.brands.models.series.view,
  },
  {
    id: '19',
    path: '/carProductionTime/:guid',
    element: <CarProductionTime />,
    label: 'سال های ساخت خودرو',
    refreshVersion: 0,
    permission:
      codingSettings.carFactory.brands.models.series.manufacturingDate.view,
  },
  {
    id: '20',
    path: '/productDetail/:guid',
    element: <ProductDetail />,
    label: 'ویژگی های محصول',
    refreshVersion: 0,
    permission: productList.detail.view,
  },
  {
    id: '21',
    path: '/product-graph/:guid',
    element: <ProductCategories />,
    label: 'گراف محصولات',
    refreshVersion: 0,
    permission: productList.graph,
  },
  {
    id: '22',
    path: '/locations-graph/:guid',
    element: <LocationsCategories />,
    label: 'گراف مکان ها',
    refreshVersion: 0,
    permission: locationManagement.locations.areas.graph,
  },
  {
    id: '23',
    path: '/shop/products/:guid/branch-insert',
    element: <ProductBranch />,
    label: 'ثبت برنچ',
    refreshVersion: 0,
    permission: productList.detail.view,
  },

  {
    id: '24',
    path: '/operation/default-settings',
    element: <WarehouseOperationDefaultSettings />,
    label: 'تنظیمات پیش‌فرض',
    refreshVersion: 0,
    permission: defaultSettings.view,
  },
  // {
  //   id: '20',
  //   path: '/operation/warehouse-sections',
  //   element: <WarehouseSectionAreasSelector />,
  //   label: 'لیست طبقات',
  // },
  {
    id: '25',
    path: '/operation/warehouse-operation-geoMap',
    element: <WarehouseOperationGeoMap />,
    label: 'نقشه انبار',
    refreshVersion: 0,
    permission: warehouseOperations.geoMap,
  },
  {
    id: '26',
    path: '/operation/entry-list',
    element: <EntryOperationList />,
    label: 'لیست عملیات ورود',
    refreshVersion: 0,
    permission: warehouseOperations.entry.view,
  },
  {
    id: '26-workspace',
    path: '/operation/entry-workspace/:guid',
    element: <EntryOperationWorkspace />,
    label: 'چیدمان ورود',
    refreshVersion: 0,
    permission: warehouseOperations.entry.detail,
  },
  {
    id: '27',
    path: '/operation/departure-list',
    element: <DepartureOperationList />,
    label: 'لیست عملیات جمع‌آوری',
    refreshVersion: 0,
    permission: warehouseOperations.departure.view,
  },
  {
    id: '27-workspace',
    path: '/operation/departure-workspace/:guid',
    element: <DepartureOperationWorkspace />,
    label: 'جمع آوری',
    refreshVersion: 0,
    permission: warehouseOperations.departure.detail,
  },
  {
    id: '28',
    path: '/operation/transfer-list',
    element: <TransferOperationList />,
    label: 'لیست ارسال‌های مستقیم',
    refreshVersion: 0,
  },
  {
    id: '28-workspace',
    path: '/operation/transfer-workspace/:guid',
    element: <TransferOperationWorkspace />,
    label: 'ارسال مستقیم',
    refreshVersion: 0,
    permission: warehouseOperations.transfer.view,
  },
  {
    id: '29',
    path: '/operation/movement-list',
    element: <MovementOperationList />,
    label: 'لیست عملیات جابه‌جایی',
    refreshVersion: 0,
    permission: warehouseOperations.movement.view,
  },
  {
    id: '29-workspace',
    path: '/operation/movement-workspace/:guid',
    element: <MovementOperationWorkspace />,
    label: 'جابه‌جایی',
    refreshVersion: 0,
    permission: warehouseOperations.movement.detail,
  },
  {
    id: '30',
    path: '/operation/active-PDA-list',
    element: <ActivePDAListPage />,
    label: 'PDA های فعال',
    refreshVersion: 0,
    permission: warehouseOperations.activePDAs.view,
  },
  {
    id: '21',
    path: '/YMS',
    element: undefined,
    label: 'مدیریت بارگیری',
    refreshVersion: 0,
    permission: categoriesPermissions.ymsManagement,
  },
  {
    id: '32',
    path: '/TMS',
    element: undefined,
    label: 'مدیریت حمل‌و‌نقل',
    refreshVersion: 0,
    permission: categoriesPermissions.tmsManagement,
  },
  {
    id: '33',
    path: '/MOM',
    element: undefined,
    label: 'مدیریت تولید',
    refreshVersion: 0,
    permission: categoriesPermissions.momManagement,
  },
  {
    id: '34',
    path: '/MES',
    element: undefined,
    label: 'عملیات تولید',
    refreshVersion: 0,
    permission: categoriesPermissions.mesOperation,
  },
  {
    id: '35',
    path: '/procurements',
    element: undefined,
    label: 'تامین',
    refreshVersion: 0,
    permission: categoriesPermissions.procurementsManagement,
  },
  {
    id: '36',
    path: '/sales',
    element: undefined,
    label: 'فروش',
    refreshVersion: 0,
    permission: categoriesPermissions.salesManagement,
  },
  {
    id: '37',
    path: '/version-control',
    element: <ApplicationsPage />,
    label: 'لیست برنامه ها',
    refreshVersion: 0,
    permission: keySettings.basicSettings.versionControl.view,
  },
  {
    id: '38',
    path: '/version-control/:guid',
    element: <VersionControlPage />,
    label: 'نسخه‌ های برنامه',
    refreshVersion: 0,
    permission: keySettings.basicSettings.versionControl.versions.view,
  },
  {
    id: '39',
    path: '/permissions',
    element: <PermissionsPage />,
    label: 'دسترسی‌ ها',
    refreshVersion: 0,
    permission: keySettings.accessLevel.permissions.view,
  },
  {
    id: '40',
    path: '/roles',
    element: <RolesPage />,
    label: 'نقش‌ ها',
    refreshVersion: 0,
    permission: keySettings.accessLevel.roles.view,
  },
  {
    id: '40-role-permissions-list',
    path: '/roles/:roleGuid/permissions-list',
    element: <RolePermissionsList />,
    label: 'لیست دسترسی‌ های نقش',
    refreshVersion: 0,
    permission: keySettings.accessLevel.roles.permissions,
  },
  {
    id: '41',
    path: '/base-roles',
    element: <BaseRolesPage />,
    label: 'نقش‌ های پایه',
    refreshVersion: 0,
    permission: keySettings.accessLevel.baseRoles.view,
  },
  {
    id: '42',
    path: '/users',
    element: <UsersPage />,
    label: 'کاربران',
    refreshVersion: 0,
    permission: usersPermissions.view,
  },
  {
    id: '42-role-list',
    path: '/users/:userGuid/role-list',
    element: <UserRoleList />,
    label: 'لیست نقش‌ های کاربر',
    refreshVersion: 0,
    permission: usersPermissions.roles,
  },
  {
    id: '42-permission-list',
    path: '/users/:userGuid/permission-list',
    element: <UserPermissionList />,
    label: 'لیست دسترسی‌ های کاربر',
    refreshVersion: 0,
    permission: usersPermissions.permissions,
  },
];

export const routesMap = new Map(routes.map(route => [route.path, route]));

export const findRouteByPath = pathname => {
  if (routesMap.has(pathname)) return routesMap.get(pathname);

  return routes.find(route => {
    const routePath = route.path;
    if (!routePath.includes(':')) return false;
    const pattern = new RegExp(`^${routePath.replace(/:[^/]+/g, '[^/]+')}$`);
    return pattern.test(pathname);
  });
};
